<template>
    <div id="editor_text">
        <editorTextChapter></editorTextChapter>
        <editorTextContext></editorTextContext>
    </div>
</template>

<script>
import editorTextChapter from '@/components/editor_textChapter.vue' //章纲概述
import editorTextContext from '@/components/editor_textContext.vue' //章纲正文
export default {
    components:{
        editorTextChapter,editorTextContext
    }
}
</script>

<style>
#editor_text{
    width: 100%;
    height: 100%;
    display: flex;
}
</style>